import { Box, Button, Stack, SvgIcon, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import useScreenSize from '../../../utils/useScreenSize';

const CourseFinishPageProgress = () => {
	const { t } = useTranslation();
	const { isXsScreen } = useScreenSize();

	const relaunchCourse = async () => {
		window.top?.postMessage({ eventType: 'relaunchCourse' }, '*');
	};

	return (
		<Stack
			data-testid="course-finish-page-progress"
			alignItems="center"
			gap={spaces.xl}
			paddingY={spaces.xxl}
		>
			<Box
				component={getMuiIcon('courseProgress')}
				sx={{
					width: isXsScreen ? '343px' : '400px',
					height: isXsScreen ? '258px' : '300px',
				}}
			/>
			<Stack gap={spaces.xs} maxWidth={448}>
				<Typography variant="h6" color={palette.text.primary} textAlign="center">
					{t("You've almost made it")}
				</Typography>
				<Typography variant="body2" color={palette.text.secondary}>
					{t("There's not much left to complete the course 100% and get your personal certificate.")}
				</Typography>
			</Stack>
			<Button
				startIcon={<SvgIcon component={getMuiIcon('play')} />}
				variant="contained"
				size="large"
				color="primary"
				onClick={relaunchCourse}
			>
				{t('Continue course')}
			</Button>
		</Stack>
	);
};

export default CourseFinishPageProgress;
